import React from 'react';
import PropTypes from 'prop-types';
import zxcvbn from 'zxcvbn';
import { getTranslatedPasswordError } from '../../../common/utils';
import withLocalization from '../../higherOrderComponents/withLocalization';
import CustomMeter from '../CustomMeter';

const PasswordStrengthMeter = ({ value, translate }) => {
  let score = 0;

  if (!getTranslatedPasswordError(value)) {
    ({ score } = zxcvbn(value));
  }

  const passwordMeterLevels = [
    'min',
    'low',
    'mid',
    'high',
    'max'
  ];

  const strengthLabels = passwordMeterLevels.map(level => translate(`passwordMeter-strength-${level}`).toLowerCase());

  const passedProps = {
    meterProps: {
      value: score,
      min: 0,
      max: passwordMeterLevels.length - 1,
      className: 'meter-password-strength',
      title: translate('passwordMeter-title', { strength: strengthLabels[score] })
    },

    displayedLabel: strengthLabels[score]
  };

  return <CustomMeter {...passedProps} />;
};

PasswordStrengthMeter.propTypes = { value: PropTypes.string.isRequired };

export default withLocalization(PasswordStrengthMeter, 'elements/customInput');